import $ from 'jquery';
import Hamburger from './hamburger';

function init() {
    const prefix = 'nav-mobile';
    const $nav = $(`#${prefix}`);
    const $dialogue = $nav.find(`.${prefix}__dialogue`);
    const $content = $nav.find(`.${prefix}__content`);
    const $body = $('body');
    let toggle = new Hamburger(`[data-${prefix}-toggle="open"]`);
    const stateAttr = 'data-block-state';
    const states = {
        hidden: 'hidden',
        transition: 'transition',
        visible: 'visible'
    }
    const timeout = 300;

    function changeState(state) {
        $nav.attr(stateAttr, states[state]);
    }

    function show() {
        $body.css('overflow', 'hidden');
        changeState('transition');
        setTimeout(() => {
            changeState('visible');
        }, timeout);
    }

    function hide() {
        changeState('transition');
        setTimeout(() => {
            changeState('hidden');
            $body.css('overflow', 'auto');
        }, timeout);
    }

    toggle.toggle(show, hide);

    $dialogue.click(function (e) {
        if (!$content.is(e.target) && $content.has(e.target).length === 0) {
            toggle.close();
            hide();
        }
    })
}

function init2() {
    const prefix = 'data-nav-mobile';
    const attrs = {};
    attrs.state = `${prefix}-section-state`;
    attrs.id = `${prefix}-section-id`;
    attrs.ref = `${prefix}-ref`;
    attrs.back = `${prefix}-back`;
    const states = {};
    states.curr = 'current';
    states.next = 'next';

    const $links = $(`[${attrs.ref}]`);
    const $back = $(`[${attrs.back}]`);

    $links.click(function (event) {
        if (!this.hasAttribute(attrs.ref)) return;
        event.preventDefault();

        const $this = $(this);
        const id = $this.attr(attrs.ref);
        changeSectionState(id, 'curr');
    });

    $back.click(function () {
        const $this = $(this);
        const $section = $this.parents(`[${attrs.id}]`);
        const id = $section.attr(attrs.id);

        changeSectionState(id, 'next');
    });

    function changeSectionState(id, state) {
        const $section = $(`[${attrs.id}="${id}"]`);

        $section.attr(attrs.state, states[state]);
    }
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('DOMContentLoaded', init2);
